/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { createSelector } from 'reselect';

const getUser = state => state.user;

export const makeUserPictures = () =>
  createSelector([getUser], user => {
    const pictures = user.roles[user.roles.default_role].pictures;

    // Make sure there are always 3 slots for polaroids.
    const polaroids = Array.from(Array(3));

    // Assign each existing polaroid to it's designated index.
    pictures
      .filter(picture => picture.index < 3)
      .forEach(picture => {
        polaroids[picture.index] = picture;
      });

    // Portfolio pictures will always be the rest of the images (from index 3 and up).
    const portfolio = [];

    // Assign each existing portfolio to it's designated index.
    pictures
      .filter(picture => picture.index > 2)
      .forEach(picture => {
        portfolio[picture.index] = picture;
      });

    // Always add an empty slot to the portfolio as long as it doesn't reach it's max limit.
    if (portfolio.length < 31) {
      portfolio[portfolio.length] = undefined;
    }

    return { polaroids, portfolio };
  });
